(function () {
  var COOKIE_NAME = 'location_popup_seen';
  var SELECTOR = 'modal-dialog[data-location-popup]';
  var editorSelected = false;

  function getCookie(name) {
    var match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : null;
  }

  function setCookie(name, value, days) {
    var expires = '';
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = '; expires=' + date.toUTCString();
    }
    document.cookie = name + '=' + encodeURIComponent(value) + expires + '; path=/; SameSite=Lax';
  }

  function removeStaleModals(keep) {
    document.querySelectorAll(SELECTOR).forEach(function (el) {
      if (el !== keep) el.remove();
    });
  }

  // Every one of the shop's own Markets domains. Used below to tell apart
  // the two situations that both show up as a bare `shpxid=` marker in
  // the URL -- see arrivedViaMarketRedirect() / arrivedFromOwnDomain().
  var SHOP_HOSTNAMES = ['lofotenseaweed.com', 'lofotenseaweed.eu', 'lofotenseaweed.no'];

  function arrivedViaMarketRedirect() {
    return /(?:^|[?&])shpxid=/.test(window.location.search);
  }

  function arrivedFromOwnDomain() {
    if (!document.referrer) return false;
    try {
      var referrerHost = new URL(document.referrer).hostname.replace(/^www\./, '');
      return SHOP_HOSTNAMES.indexOf(referrerHost) !== -1;
    } catch (e) {
      return false;
    }
  }

  function prefillDetectedCountry(modal) {
    var select = modal.querySelector('select[name="country_code"]');
    if (!select || !window.Shopify || !window.Shopify.routes || !window.Shopify.routes.root) return;

    var servedCode = select.value;

    var url = window.Shopify.routes.root + 'browsing_context_suggestions.json?country[enabled]=true';

    fetch(url, { headers: { Accept: 'application/json' } })
      .then(function (response) {
        return response.ok ? response.json() : null;
      })
      .then(function (data) {
        var detected =
          data &&
          data.detected_values &&
          data.detected_values.country &&
          data.detected_values.country.handle;
        if (!detected || detected === servedCode) return;

        if (select.value !== servedCode) return;

        var option = select.querySelector('option[value="' + detected + '"]');
        if (!option) return;

        select.value = detected;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      })
      .catch(function () {
        /* leave the served country selected */
      });
  }

  function setupCountryCombobox(modal, form) {
    var select = form.querySelector('select[name="country_code"]');
    var selectWrap = select && select.closest('.location-popup-modal__select-wrap');
    var field = selectWrap && selectWrap.closest('.location-popup-modal__field');
    if (!select || !selectWrap || !field) return;

    var options = Array.prototype.map.call(select.querySelectorAll('option'), function (option) {
      return { value: option.value, label: option.textContent.trim() };
    });
    if (options.length < 8) return;

    function labelFor(value) {
      var match = options.filter(function (opt) {
        return opt.value === value;
      })[0];
      return match ? match.label : '';
    }

    function valueForLabel(label) {
      var needle = label.trim().toLowerCase();
      var match = options.filter(function (opt) {
        return opt.label.toLowerCase() === needle;
      })[0];
      return match ? match.value : null;
    }

    var listId = 'PopupCountryList-' + (modal.dataset.sectionId || 'popup');

    var datalist = document.createElement('datalist');
    datalist.id = listId;
    options.forEach(function (opt) {
      var dOption = document.createElement('option');
      dOption.value = opt.label;
      datalist.appendChild(dOption);
    });

    var visibleLabel = field.querySelector('label');

    var input = document.createElement('input');
    input.type = 'text';
    input.className = select.className;
    input.setAttribute('list', listId);
    input.setAttribute('autocomplete', 'off');
    input.setAttribute('spellcheck', 'false');
    if (visibleLabel && visibleLabel.id) input.setAttribute('aria-labelledby', visibleLabel.id);
    input.placeholder = modal.dataset.filterPlaceholder || 'Type or choose a country';
    input.value = labelFor(select.value);

    input.addEventListener('focus', function () {
      input.value = '';
    });

    input.addEventListener('input', function () {
      var matched = valueForLabel(input.value);
      if (matched && matched !== select.value) {
        select.value = matched;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });

    input.addEventListener('blur', function () {
      input.value = labelFor(select.value);
    });

    input.addEventListener('keydown', function (event) {
      if (event.key === 'Enter') event.preventDefault();
    });

    select.addEventListener('change', function () {
      input.value = labelFor(select.value);
    });

    select.style.display = 'none';
    select.setAttribute('aria-hidden', 'true');
    select.tabIndex = -1;
    selectWrap.insertBefore(input, select);
    selectWrap.appendChild(datalist);
  }

  function waitForCustomerPrivacy(callback, timeoutMs) {
    var deadline = Date.now() + (timeoutMs || 2000);
    (function poll() {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (cp && typeof cp.shouldShowBanner === 'function') {
        callback(cp);
        return;
      }
      if (Date.now() >= deadline) {
        callback(null);
        return;
      }
      window.setTimeout(poll, 50);
    })();
  }

  function setupLocationAndConsentActions(modal, form) {
    var consentGroup = form.querySelector('[data-location-popup-consent-actions]');
    var simpleButton = form.querySelector('[data-location-popup-simple-action]');
    var manageLink = form.querySelector('[data-location-popup-manage-cookies]');

    function submitForm() {
      if (typeof form.requestSubmit === 'function') {
        form.requestSubmit();
      } else {
        form.submit();
      }
    }

    waitForCustomerPrivacy(function (cp) {
      // This is our ONLY cookie prompt on the site — the native Shopify
      // banner is hidden unconditionally whenever this section renders
      // (see the CSS comment at the top of this section's style block),
      // so if we don't ask here, nobody ever asks. That makes the choice
      // of fallback when Shopify's own privacy script can't be reached in
      // time (slow network, a blocked script, Tor, certain browser
      // privacy tooling, or theme-preview mode, which never loads it at
      // all) genuinely consequential, not a cosmetic default.
      //
      // The previous version defaulted to "no need to ask" whenever cp
      // was unavailable or threw. Combined with the fact that clicking
      // the resulting plain "Update" button sets our own 90-day
      // "don't show this popup again" cookie, a single unlucky visit —
      // one slow load, one blocked script — could leave a visitor who
      // genuinely needed to be asked uncounted for three months, with no
      // fallback banner to catch them since ours is the only one shown.
      //
      // Flipped here: only an EXPLICIT `false` from Shopify's own API
      // counts as "this visitor is already covered" (e.g. already
      // decided on an earlier visit, or a privacy signal Shopify itself
      // chose to honor as an opt-out). Anything else — the API never
      // showing up, throwing, or returning something unexpected — now
      // defaults to asking. Worst case with this default, a visitor who
      // already answered gets asked once more and re-confirms in one
      // click; worst case with the old default was never truly asking a
      // visitor who was supposed to be asked at all.
      var needsConsent = true;
      if (cp) {
        try {
          needsConsent = cp.shouldShowBanner() !== false;
        } catch (e) {
          needsConsent = true;
        }
      }

      if (needsConsent && consentGroup) {
        consentGroup.hidden = false;
        if (simpleButton) simpleButton.hidden = true;
      } else if (simpleButton) {
        simpleButton.hidden = false;
        if (consentGroup) consentGroup.hidden = true;
      }
    });

    if (consentGroup) {
      consentGroup.querySelectorAll('[data-location-popup-consent]').forEach(function (button) {
        button.addEventListener('click', function (event) {
          event.preventDefault();

          var granted = button.getAttribute('data-location-popup-consent') === 'all';
          var consent = {
            analytics: granted,
            marketing: granted,
            preferences: granted,
            sale_of_data: granted,
          };

          var cp = window.Shopify && window.Shopify.customerPrivacy;
          if (cp && typeof cp.setTrackingConsent === 'function') {
            try {
              cp.setTrackingConsent(consent, submitForm);
              return;
            } catch (e) {
              // fall through to submitting anyway — never let a consent
              // API failure trap the visitor on an unresponsive popup.
            }
          }
          submitForm();
        });
      });
    }

    if (manageLink) {
      manageLink.addEventListener('click', function (event) {
        event.preventDefault();
        if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') {
          window.privacyBanner.showPreferences();
        }
      });
    }
  }

  function bind(modal) {
    if (!modal || modal.dataset.locationPopupBound || typeof modal.show !== 'function') return;
    modal.dataset.locationPopupBound = 'true';

    var rememberDays = parseInt(modal.dataset.remember, 10) || 30;
    var delay = parseInt(modal.dataset.delay, 10) || 0;

    function remember() {
      setCookie(COOKIE_NAME, '1', rememberDays);
    }

    modal.querySelectorAll('[data-location-popup-dismiss]').forEach(function (button) {
      button.addEventListener('click', function () {
        remember();
        modal.hide();
      });
    });

    var form = modal.querySelector('.location-popup-modal__form');
    if (form) {
      form.addEventListener('submit', remember);
      setupLocationAndConsentActions(modal, form);
      setupCountryCombobox(modal, form);
    }

    if (document.documentElement.classList.contains('shopify-design-mode')) {
      if (editorSelected) modal.show();
      return;
    }

    if (getCookie(COOKIE_NAME)) {
      remember();
      return;
    }

    // Shopify's cross-domain Markets redirect (the `shpxid=` marker) fires
    // in two situations that look identical from the query string alone:
    //
    //   1. A visitor explicitly picked a country or language -- via this
    //      popup's own form, or the header's country selector -- and that
    //      choice happens to live on a different market domain (e.g.
    //      picking Germany while on lofotenseaweed.com bounces them to
    //      lofotenseaweed.eu). They already made their choice; asking
    //      again the instant they land is exactly the double-ask we don't
    //      want.
    //   2. A visitor's FIRST-EVER contact with the shop -- direct
    //      navigation, a search result, an ad link, a fresh Tor circuit --
    //      gets auto-redirected by Shopify's own geolocation before they
    //      ever see a page, with no chance to answer anything.
    //
    // Our "seen" cookie is per-domain and doesn't travel with a
    // cross-domain redirect, so shpxid alone can't tell these two apart.
    // document.referrer can: case 1 always arrives FROM one of our own
    // domains (they were just on that page, in this tab, an instant ago),
    // case 2 arrives from an external referrer or none at all (a fresh
    // Tor circuit typically sends no referrer either). We only skip
    // showing the popup for case 1 -- an already-made choice -- and still
    // ask in case 2.
    if (arrivedViaMarketRedirect() && arrivedFromOwnDomain()) {
      remember();
      return;
    }

    prefillDetectedCountry(modal);

    window.setTimeout(function () {
      modal.show();
    }, delay);
  }

  function refresh() {
    var modals = document.querySelectorAll(SELECTOR);
    if (!modals.length) return;
    var latest = modals[modals.length - 1];
    removeStaleModals(latest);
    bind(latest);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refresh);
  } else {
    refresh();
  }

  document.addEventListener('shopify:section:load', refresh);

  document.addEventListener('shopify:section:select', function (event) {
    var modal = document.querySelector(SELECTOR);
    if (!modal || event.detail.sectionId !== modal.dataset.sectionId) return;
    editorSelected = true;
    modal.show();
  });

  document.addEventListener('shopify:section:deselect', function (event) {
    var modal = document.querySelector(SELECTOR);
    if (!modal || event.detail.sectionId !== modal.dataset.sectionId) return;
    editorSelected = false;
    modal.hide();
  });
})();
